// import theme from 'presentation/styles/theme'
import styled, { css } from 'styled-components'
import { CardProps } from '.'

type CardWrapperProps = Pick<
  CardProps,
  'shadow' | 'radius' | 'bgColor' | 'padding' | 'disabled' | 'onClick'
>

type IconWrapperProps = Pick<CardProps, 'iconColor'>

export const CardWrapper = styled.div<CardWrapperProps>`
  ${({
    theme,
    shadow = 'medium',
    radius = 'xsmall',
    bgColor = 'white',
    padding = '16px',
    disabled = false,
    onClick
  }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${disabled
      ? theme.ds.colors.neutral100
      : theme.ds.colors[bgColor]};
    box-shadow: ${theme.ds.shadows[shadow]};
    border: none;
    border-radius: ${theme.ds.typography.border.radius[radius]};
    padding: ${padding};
    cursor: ${onClick && !disabled ? 'pointer' : 'default'};
  `}
`

export const IconWrapper = styled.div<IconWrapperProps>`
  ${({ theme, iconColor }) => css`
    display: flex;
    padding: 4px 16px 4px 0;

    svg {
      width: 32px;
      height: 32px;

      path {
        fill: ${theme.ds.colors[iconColor!]};
      }
    }
  `}
`
